<script>
  import Banner from '../utility/banner.svelte'
  import Contact from '../parts/contact.svelte'
  import Footer from '../parts/footer.svelte'
  export let title

  document.documentElement.scrollTop = 0
</script>

<svelte:head>
  <title>
    {title} - Devanga Sowdeshwari Amman Association of North America (DSAANA)
  </title>
</svelte:head>

<Banner title="{title}" />

<section class="AboutUs">
  <div>
    <p class="text-center">
      Devanga Sowdeshwari Amman Association of North America (DSAANA) is a
      non-profit organization with a mission to build a vibrant community and
      promote rich culture.
    </p>
  </div>

  <div class="block">
    <div>
      <h2>Cultural & Spiritual Empowerment</h2>
      <p>
        Our main goal is to construct a spiritual place for our community in our
        vicinity and the purpose of Spiritual and cultural center is to support
        and advance the exploration and expression of spiritually, religious
        life, faith-traditions, values and philosophies of life within the
        context of our society. We intend to provide access to activities and
        programs that enable interested ones to pursue full spiritual growth and
        development and to foster a serene atmosphere in which interested people
        may freely practice our religion, spirituality, and faith. <br /><br />

        This religious center provide opportunities to be centered in a caring
        community, explore the connections between faith-traditions and real
        world complexities, make a difference in the lives of others through
        service work, and grow in a sense of their own abilities and
        self-awareness.
      </p>
    </div>
    <img
      src="assets/images/services/Cultural and Spritual Empowerment Image.png"
      alt="" />
  </div>

  <div class="block">
    <div>
      <h2>Community Outreach</h2>
      <p>
        We do Community outreach refers as a service endeavor that “reaches out”
        to a community in need. In most cases, community outreach is targeted
        toward a particular need and therefore implies helping a certain group
        of people. Our community outreach effort may focus on supplying a good
        and a service where ever required. If you would like to help a community
        in a particular way, bring in to us and we will do the needful as
        required.
      </p>
    </div>
    <img src="assets/images/services/cm.png" alt="" />
  </div>

  <div class="block">
    <div>
      <h2>Fundraising</h2>
      <p>
        Community service opportunities depend as much on donated money as they
        do on donated time and goods, fundraising campaigns are constantly done
        by us on a need basis. We involve ourselves in various fundraising
        activities like door-to-door canvassing, outreach to businesses and
        corporations and, where our organization is involved, grant writing. As
        with community outreach, fundraising opportunities can be found in every
        conceivable area of service and welcome anyone that is willing to donate
        their time or skills to raising money for a noble cause.
      </p>
    </div>
    <img src="assets/images/services/fr.png" alt="" />
  </div>

  <div class="block">
    <div>
      <h2>Educating / Tutoring</h2>
      <p>
        We involve in educating opportunities which include but are not limited
        to traditional classroom situations. For example, teaching and educating
        opportunities also focus on things such as: educating about communicable
        diseases, teaching a trade or a skill, money management and educating to
        improve literacy. <br /><br />
        Tutoring can be performed in relation to a particular community service project
        or on a long-term basis through a community betterment organization. In many
        cases, our volunteers find tutoring more rewarding than teaching or educating
        because it gives them a closer look at a student’s progress.
      </p>
    </div>
    <img src="assets/images/services/stg.png" alt="" />
  </div>

  <div class="block">
    <div>
      <h2>Women Empowerment</h2>
      <p>
        Our non-profit provides knowledge and opportunities to support the
        economic aspirations, self-sufficiency, and emotional well-being of
        individuals so they may live with hope, security, and dignity. We
        support the Women's Empowerment Principles and Sustainable Development
        Goals through awareness; best practice sharing, recognition and
        community building by promoting partnerships between all stakeholders
        committed to advancing gender equality and the economic empowerment of
        women in our community.
      </p>
    </div>
    <img src="assets/images/services/we.png" alt="" />
  </div>

  <div class="block">
    <div>
      <h2>Youth Empowerment</h2>
      <p>
        Our Organization creates and increase volunteer opportunities to enrich
        youth, address community needs and develop a lifetime commitment to
        service. Help Develop social competencies – identity development,
        compassion, leadership, confidence and self-esteem. Support younger
        generation to become active leaders and citizens and serves as an
        important tool for engagement in society. Provide an opportunity to
        learn new skills and valuable work experience Develop significant
        relationships with like-minded peers and others.
      </p>
    </div>
    <img src="assets/images/services/ye.png" alt="" />
  </div>

  <br /><br /><br /><br /><br />
</section>

<!-- <Contact /> -->
<Footer />

<style lang="scss">
  .AboutUs {
    width: 90%;
    margin: auto;

    .block {
      display: grid;
      grid-template-columns: 1fr;

      img {
        width: 95%;
        margin: 0 2.5%;
      }

      div {
        width: 70%;
        margin: auto 15%;
        p {
          text-align: justify;
        }
      }

      @media only screen and (min-width: 1050px) {
        grid-template-columns: 6fr 4fr;

        &:nth-child(even) {
          grid-template-columns: 4fr 6fr;
          div {
            order: 2;
          }

          img {
            order: 1;
          }
        }
      }
    }

    div {
      margin-top: 50px;
    }
  }
</style>
